import { AxiosError } from 'axios';

export enum ErrorCodes {
  NOT_ACTIVATED = 'NOT_ACTIVATED',
  TOO_MANY_REQUESTS = 'TOO_MANY_REQUESTS',
  INVALID_TOKEN = 'INVALID_TOKEN',
}

export type ErrorMessage = {
  message: string;
  code?: ErrorCodes;
  options?: any;
};

export type BackendError<Error> = {
  errors: Error;
};

export type Errors = ErrorMessage[];

export type ErrorType<Input> = {
  [K in keyof Input]?: Errors;
} & { root?: Errors };

export type Error<Input> = AxiosError<BackendError<ErrorType<Input>>>;

export default <Input extends ErrorType<Input>>(
  errors: Input,
  callback: (field: keyof Input, error: string, code?: ErrorCodes, options?: any) => void,
) => {
  Object.entries(errors).forEach((entry) => {
    const key = entry[0] as keyof Input;
    const value = entry[1] as Errors;
    value.forEach(({ message, code, options }) => {
      callback(key, message, code, options);
    });
  });
};
